import classNames from "classnames/bind";
import styles from "../../CaseChatCard.module.scss";
import {Check, X, Info} from 'lucide-react';
const cx = classNames.bind(styles);
function CasePendingCard({ avatarUrl,
                             senderName,
                             type,
                             caseCreatedDate,
                             castType,
                             onClickAccept,
                             onClickReject,
                             onClickDetails
    }) {
    return (
        <div className= "border-bottom border-translucent py-3 position-relative px-3">
            <div className="d-flex align-items-center justify-content-between position-relative">
                <div className="d-flex w-100">
                    <div className="me-3 avatar avatar-m flex-shrink-0">
                        <img alt="avatar" className="rounded-circle" src={avatarUrl} />
                    </div>
                    <div className="flex-grow-1 w-100">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fs-9 mb-0 text-body-emphasis">{senderName}</h4>
                            <span className="fs-10 badge-bt badge-bt-info badge">{type}</span>
                        </div>
                        <div className="d-flex justify-content-between my-2">
              <span className={cx("text-ellipsis", "case-title", "me-1 fs-9")}>
                {castType}
              </span>
                            <span className="me-1 fw-semibold fs-9">{caseCreatedDate}</span>
                        </div>
                        <div>
                            <span className="fs-10 badge-bt badge-bt-success badge cursor-pointer me-3" onClick={onClickAccept}>
                                <span className="badge-label">Accept</span>
                                <Check size={12} className="ms-1" />
                            </span>
                            <span className="fs-10 badge-bt badge-bt-warning badge cursor-pointer me-3" onClick={onClickReject}>
                                <span className="badge-label">Reject</span>
                                <X size={12} className="ms-1" />
                            </span>
                            <span className="fs-10 badge-bt badge-bt-info badge cursor-pointer" onClick={onClickDetails}>
                                <span className="badge-label">Details</span>
                                <Info size={12} className="ms-1" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CasePendingCard;